import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const LocalPassengerIcon: FC<IconProps> = ({ width = 40, height = 40, ...rest }) => (
  <Icon type="LocalPassenger" width={width} height={height} alt="LocalPassenger" {...rest} />
)
